module.exports = __webpack_public_path__ + "img/navbar-close-restaurant.ea6ea3f2.svg";